module.exports = __webpack_public_path__ + "static/media/Inter-Regular.a4a73795.ttf";